import { render, staticRenderFns } from "./decoration-policy-form.vue?vue&type=template&id=4bdaad2e&scoped=true&"
import script from "./decoration-policy-form.vue?vue&type=script&lang=js&"
export * from "./decoration-policy-form.vue?vue&type=script&lang=js&"
import style0 from "./decoration-policy-form.vue?vue&type=style&index=0&id=4bdaad2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdaad2e",
  null
  
)

export default component.exports